import { authSlice } from "./slice";

export const {
  setSelectedInstituteType,
  setValidatingSession,
  resetAuthSlice,
  setRegisterData,
} = authSlice.actions;
